const MSK_TIME_ZONE = 'Europe/Moscow';

const dateTimeFormatter = new Intl.DateTimeFormat('ru', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
  timeZone: MSK_TIME_ZONE,
});

const costFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Unix seconds -> "DD.MM.YYYY, HH:mm" (Moscow time), same as legacy `components/Date`. */
export const formatUnixDateTime = (seconds: number | string | null | undefined): string => {
  const value = Number(seconds);
  return Number.isFinite(value) && value > 0 ? dateTimeFormatter.format(value * 1000) : '';
};

/** Value of `<input type="date|datetime-local">` -> unix seconds, or '' when empty. */
export const inputValueToUnix = (value: string): number | '' => {
  if (!value) return '';
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? '' : Math.floor(ms / 1000);
};

export const formatCost = (value: number | string | null | undefined): string =>
  costFormatter.format(Number(value) || 0);

const pad = (n: number) => String(n).padStart(2, '0');

/** Unix seconds -> value of `<input type="datetime-local">` (browser local time), '' when empty. */
export const unixToInputValue = (seconds: number | string | null | undefined): string => {
  const value = Number(seconds);
  if (!Number.isFinite(value) || value <= 0) return '';
  const d = new Date(value * 1000);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const dateFormatter = new Intl.DateTimeFormat('ru-RU', { timeZone: MSK_TIME_ZONE });

/** Unix seconds -> "DD.MM.YYYY" (Moscow time), '' when empty. */
export const formatUnixDate = (seconds: number | string | null | undefined): string => {
  const value = Number(seconds);
  return Number.isFinite(value) && value > 0 ? dateFormatter.format(value * 1000) : '';
};
